import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, matchPath } from "react-router-dom";
import styled from "styled-components";
import Header from "../common/header";
import Paper from "../common/paper";
import ScheduleEditRoute from "./common/edit.route/schedule";
import SOE from "./soe";
import SOEForecast from "./soe.forecast";

const ScheduleStudyPlan = () => {
  const [showDetailsButton, setShowDetailsButton] = useState(false);
  const location = useLocation();

  const isExactMatch = (path) =>
    matchPath({ path, end: true }, location.pathname);

  useEffect(() => {
    if (isExactMatch("/ctpo/study-plans/:id/soe/:scheduleId/forecast")) {
      setShowDetailsButton(false);
    } else if (isExactMatch("/ctpo/study-plans/:id/soe/:scheduleId")) {
      setShowDetailsButton(true);
    } else {
      setShowDetailsButton(false);
    }
  }, [location]);

  return (
    <Container>
      <Paper>
        <React.Fragment>
          <HeaderContainer>
            <Header showDetailsButton={showDetailsButton} />
          </HeaderContainer>
          <Routes>
            <Route
              path="forecast"
              element={<ScheduleEditRoute component={SOEForecast} />}
            />
            <Route
              index
              element={<ScheduleEditRoute component={SOE} />}
            />
          </Routes>
        </React.Fragment>
      </Paper>
    </Container>
  );
};

export default ScheduleStudyPlan;

const Container = styled.div`
  min-width: 1300px;
  width: 100%;
  position: sticky;
`;

const HeaderContainer = styled.div`
  position: sticky;
  top: 3.8em;
  z-index: 10000;
  background: var(--White);
  border-radius: 4px;
  color: var(--White);
  padding: 1em 0 0 0;
`;
